/**
 * Dividend date to start showing next dividend date
 */
export const VALID_DIVIDEND_DATE = new Date(2023, 0, 11);
/**
 * Dividend date to display on portfolio table for next dividend
 */
export const NEXT_DIVIDEND_DATE = new Date(2023, 3, 30);
